import { keysToSnake } from '#/api/adapters/wireCase';

function emptyToNull(value) {
  if (value == null) {
    return null;
  }
  const trimmed = String(value).trim();
  return trimmed === '' ? null : trimmed;
}

/**
 * Create：repairItemId＋repairReportNo。
 * 禁送 SN／品名／產品／問題／reservationId／status／報表內容。
 */
export function toRepairReportCreateBody(values = {}) {
  return {
    repairItemId: emptyToNull(values.repairItemId),
    repairReportNo: emptyToNull(values.repairReportNo),
  };
}

function mapInspectionItemToWrite(item) {
  if (!item || typeof item !== 'object') {
    return null;
  }
  return {
    description: emptyToNull(item.description),
    result: emptyToNull(item.result),
  };
}

/**
 * PATCH：可改內容欄＋updatedAt；禁送 repairItemId／單號／status／reservationId。
 * **禁送** serialNo／itemName／accessories／problemDescription（repair_item 唯讀快照；傳入 → 400）。
 * `inspectionItems` 若出現＝整表取代（可不送 id）；wire 頂層扁平（非 nested inspection）。
 */
export function toRepairReportUpdateBody(values = {}) {
  const updatedAt = values.updatedAt ?? values.record?.updatedAt ?? null;
  const payload = {};

  if (Object.prototype.hasOwnProperty.call(values, 'repairDate')) {
    payload.repairDate = emptyToNull(values.repairDate);
  }
  if (Object.prototype.hasOwnProperty.call(values, 'resolution')) {
    payload.resolution = emptyToNull(values.resolution);
  }
  if (Object.prototype.hasOwnProperty.call(values, 'remark')) {
    payload.remark = emptyToNull(values.remark);
  }
  if (Object.prototype.hasOwnProperty.call(values, 'inspectionConclusion')) {
    payload.inspectionConclusion = emptyToNull(values.inspectionConclusion);
  }
  if (Object.prototype.hasOwnProperty.call(values, 'inspectionItems')) {
    payload.inspectionItems = (values.inspectionItems ?? [])
      .map(mapInspectionItemToWrite)
      .filter(Boolean);
  }
  if (updatedAt != null && updatedAt !== '') {
    payload.updatedAt = updatedAt;
  }

  return payload;
}

/** complete：body 僅 `{ updatedAt }` */
export function toRepairReportCompleteBody(payload = {}) {
  const updatedAt = payload.updatedAt ?? payload.record?.updatedAt ?? null;
  const body = {};
  if (updatedAt != null && updatedAt !== '') {
    body.updatedAt = updatedAt;
  }
  return body;
}

/** refuse：`refuseReason`＋`updatedAt` */
export function toRepairReportRefuseBody(payload = {}) {
  const updatedAt = payload.updatedAt ?? payload.record?.updatedAt ?? null;
  const body = {
    refuseReason: emptyToNull(payload.refuseReason),
  };
  if (updatedAt != null && updatedAt !== '') {
    body.updatedAt = updatedAt;
  }
  return body;
}

/** cancel-draft：`reason`＋`updatedAt` */
export function toRepairReportCancelDraftBody(payload = {}) {
  const updatedAt = payload.updatedAt ?? payload.record?.updatedAt ?? null;
  const body = {
    reason: emptyToNull(payload.reason),
  };
  if (updatedAt != null && updatedAt !== '') {
    body.updatedAt = updatedAt;
  }
  return body;
}

export function serializeRepairReportCreate(values) {
  return keysToSnake(toRepairReportCreateBody(values));
}

export function serializeRepairReportUpdate(values) {
  return keysToSnake(toRepairReportUpdateBody(values));
}

export function serializeRepairReportComplete(payload) {
  return keysToSnake(toRepairReportCompleteBody(payload));
}

export function serializeRepairReportRefuse(payload) {
  return keysToSnake(toRepairReportRefuseBody(payload));
}

export function serializeRepairReportCancelDraft(payload) {
  return keysToSnake(toRepairReportCancelDraftBody(payload));
}
